<template>
    <div class="mt-4">
        <p class="font-italic text-warning fs-5">{{ message }}</p>
    </div>
</template>

<script>
export default {
    props: ['message'],
};
</script>

<style scoped></style>
